const initialStateMY = {
  // PERSONAL INFORMATION
  firstName: '',
  lastName: '',
  middleName: '',
  dateOfBirth: '',
  gender: '',

  // OCR FILE NAMES
  fileNames: {
    file1: '',
    file2: '',
  },

  // IDENTITY DETAILS
  nationalIDNo: '',

  // CURRENT RESIDENTIAL ADDRESS
  streetNo: '',
  streetName: '',
  city: '',
  state: '',
  postCode: '',

  // REFERENCE NUMBER
  reportingReference: '',

  // TERMS AND CONDITIONS
  nationalIdConsentObtained: false,
  creditBureauConsentObtained: false,

  // DATA SOURCES
  countryDataSources: {},

  // ERROR HANDLING
  errors: {},
};

export default initialStateMY;
